import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { NavController, Events, NavParams } from 'ionic-angular';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { StoreLocatorData } from '../../providers/store-locator-data';
import { Utils } from '../../../../providers/utils';
@Component({
	selector: 'page-store-info-full',
	templateUrl: 'store-info.full.html'
})
export class StoreInfoPageFull extends PageBaseFull {
	storeModel = {};
	//zoom: number = 8;
	storeId = '';

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public storeLocatorData: StoreLocatorData,
		private navParams: NavParams,
	) {
		super(settings, events, nav, userData);
		this.storeId = navParams.get('id');

	}


	ngAfterViewInit() {

	}

	public getStoreInfo() {
		this.storeLocatorData.getStore(this.storeId).subscribe(store => {
			if (store && store.services) {
				store.services = Utils.toArray(store.services).reverse();
				store.servicesTxt = store.services.map(service => {
					return service.value.name;
				}).join(', ');
			}
			this.storeModel = store;
			if (this.storeModel['storeHours'])
				this.storeModel['storeHours'] = JSON.parse(this.storeModel['storeHours']);
		});

	}

	ionViewDidEnter() {
		this.getStoreInfo();
	}
}


// WEBPACK FOOTER //
// ./src/modules/store-locator/pages/store-info/store-info.full.ts